import { useDispatch } from 'react-redux';
import EditableImage from '../../../components/editable-image/EditableImage';
import { removeOrganizationDescriptionImage, updateOrganizationDescriptionImage } from '../../organization-actions';
import Loading from '../../../components/Loading';
import styles from './edit-organization-description-image.module.less';
import { showErrorModal } from '../../../global-message/global-message-actions';

const EditOrganizationDescriptionImage = ({ organization, editable = false }) => {
    const dispatch = useDispatch();

    const uploadImage = (file) => {
        return dispatch(updateOrganizationDescriptionImage({ id: organization.id, file }));
    };

    const removeImage = () => {
        return dispatch(removeOrganizationDescriptionImage(organization.id));
    };

    return (
        <EditableImage
            editable={editable}
            placeholder={
                <div className={styles.imagePlaceholder}>
                    <div>
                        <i className="fa-regular fa-image-landscape fa-2x" aria-hidden="true" />
                        <div className={styles.imagePlaceholderTitle}>Legg til bilde (1200 x 624)</div>
                        <div className={styles.imagePlaceholderText}>Bilder gjør seg best i liggende format.</div>
                    </div>
                </div>
            }
            placeholderLoading={
                <div className={styles.imagePlaceholder}>
                    <Loading />
                    <div>Laster opp..</div>
                </div>
            }
            onDropRejected={() => {
                dispatch(showErrorModal('Bildefilen du prøver å laste opp støttes ikke'));
            }}
            uploadHandler={uploadImage}
            removeImageHandler={removeImage}
            src={organization.description_image}
        >
            <div
                style={{
                    backgroundImage: `url(${organization.description_image})`,
                }}
                className={styles.fullImage}
            />
        </EditableImage>
    );
};

export default EditOrganizationDescriptionImage;
